module.exports = __webpack_public_path__ + "img/h5_home_1.b5a4ceb0.jpg";